const passengers = {
  table: {
    headers: {
      createBtn: 'Erstellen',
      name: 'Name',
      email: 'E-Mail',
      phone: 'Telefon',
      baseAddress: 'Privatadresse',
      alternateAddress: 'Alternative Adresse',
      occupationAddress: 'Schule',
      createdAt: 'Erstellt am',
      profile: 'Profil',
    },
  },
};

export default passengers;
